<template>
	<ValidationProvider :name="$attrs.name" :rules="rules" v-slot="{ errors }">
		<div class="text-h4 my-3" v-html="question.options.label[lang]"></div>

		<v-textarea
			:error-messages="errors"
			v-model="inputValue"
			:hint="question.options.hint ? question.options.hint[lang] : ''"
			:persistent-hint="question.options.persistentHint"
			:outlined="question.options.outlined"
			:solo="question.options.solo"
			:min="question.options.min"
			:max="question.options.max"
			:rows="question.options.rows"
			:hide-details="!question.options.persistentHint"
			class="mb-6 mb-sm-8 pt-1"
			:clear-icon="question.options.clearIcon"
			:clearable="question.options.clearable"
			@change="setValue()"
		></v-textarea>
	</ValidationProvider>

</template>

<script>
import {ValidationProvider} from "vee-validate";
import AppStore from "../../../stores/AppStore";
import _ from "lodash";
import {EventBus} from "../../../services/Request";

export default {
	name: 'textarea-viewer',

	components: {
		ValidationProvider
	},

	props: {
		value: {
			type: [Object],
			default() {
				return {}
			}
		},
		lang: {
			type: [String],
			default: 'fr'
		},
		rules: {
			type: [Object, String],
			default: ""
		},
		questionIndex: {
			type: [Number],
			default: 0
		},
	},

	data: () => ({
		inputValue : ''
	}),

	mounted() {

	},

	created() {
		if (!_.isEmpty(AppStore.rating.questions_answers) && AppStore.rating.questions_answers[this.question.id]) {
			this.inputValue = AppStore.rating.questions_answers[this.question.id].content
		}
	},

	computed: {
		question: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit('input', newValue)
			}
		},
	},

	watch: {},

	methods: {
		setValue() {
			// console.info('setValue from textarea')
			this.$set(AppStore.rating.questions_answers, this.question.id, {
				question_id: this.question.id,
				content: this.inputValue
			})
			const conditionedQuestion = _.find(AppStore.conditionedQuestion, (q) => {
				return q.conditional_question_id.id === this.question.id
			});

			// console.log(conditionedQuestion)
			if (!_.isEmpty(conditionedQuestion)) {
				// console.log("CONDITIONED QUESTION")
				if (conditionedQuestion.conditional_answer == this.inputValue) {
					// console.log('set')
					// console.log('qi'+conditionedQuestion.id + 'remove d-none')
					EventBus.$emit('update-question', {
						id: conditionedQuestion.id,
						show: true
					})
				} else {
					// console.log('qi'+conditionedQuestion.id + ' d-none')
					EventBus.$emit('update-question', {
						id: conditionedQuestion.id,
						show: false
					})
				}
			}

			// console.log(AppStore.rating)
		}
	}
};
</script>
